// src/Pages/TestTop.js
import React from "react";
import { ContactButton } from "../Parts/ContactButton";
import Before from "../Components/Before";
import Steps from "../Components/Steps";
import CallToAction from "../Components/CallToAction";

export default function TestTop() {
  return (
    <main className="text-white bg-[#0E1B3D]">
      <Hero />

      {/* 既存セクション */}
      <Before />
      <Steps />
      <CallToAction />
    </main>
  );
}

function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* 背景あしらい */}
      <div className="absolute inset-0 pointer-events-none">
        {/* 明るめネイビー */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#13265A] via-[#0E1B3D] to-[#0B1733]" />

        {/* やさしいブロブ */}
        <div className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-[#3B82F6]/25 blur-3xl" />
        <div className="absolute -bottom-40 -right-40 w-[560px] h-[560px] rounded-full bg-[#60A5FA]/20 blur-3xl" />
      </div>

      {/* コンテンツ */}
      <div className="relative z-10">
        <div className="mx-auto max-w-6xl px-5 sm:px-8 min-h-[90vh] flex items-center">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center w-full">
            {/* 左：テキスト */}
            <div className="text-left">
              <img
                src="/images/camarago_logo_simple.png"
                alt="camarago logo"
                className="w-56 sm:w-64 hidden"
              />

              <h2 className="mt-8 font-['ZenOldMincho'] leading-tight text-[clamp(24px,4.5vw,45px)] text-white/95">
                <span className="block">複雑なセキュリティを、</span>
                <span className="block">シンプルに。</span>
              </h2>

              <h1 className="mt-8 text-[clamp(42px,8vw,80px)] leading-[0.95] font-bold font-[asatmosphere] tracking-wide text-brand">
                CAMARAGO
              </h1>

              <div className="mt-10">
                <ContactButton />
              </div>
            </div>

            {/* 右：イラスト（重ならない） */}
            <div className="flex justify-center lg:justify-end">
              <img
                src="/images/creativity.png"
                alt="CAMARAGO サービスの流れ"
                className="
                  w-full
                  max-w-[520px]
                  sm:max-w-[600px]
                  lg:max-w-[680px]
                  object-contain
                "
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
